

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { saleAccountService, storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';
import { SaleAccount } from '@/models/admin/sale.account';


@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaleAccountSavePage extends Base {
  public stores: any[];
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public disableSubmitButton: boolean = false;
  public created(): void {

    this.setFields();
  }
  public saleAccount: SaleAccount = {
    id: 0,
    companyNumber: '',
    make: '',
    modelCode: '',
    model: '',
    inventoryAccountNumber: '',
    saleAccountNumber: '',
    saleGroup: '',
    inventoryAccountDescription: '',
    saleAccountDescription: '',
    department: '',
    uid: '',
    storeId: 0
  };


  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'SaleAccount' },
        });
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: "Back",
      disabled: false,
      visible: true,
      class: 'btn',
      label: "Back",
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'saleaccount');

    this.storeId = Number(this.$route.params.storeId);
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.id) {
      this.getSaleAccountById(this.$route.params.id);
    }
    this.getStores();
  }

  public validateSaleAccount(): Vue & { validate: () => boolean } {
    return this.$refs.saleAccountForm as Vue & { validate: () => boolean };
  }

  public async submitSaleAccount(): Promise<void> {
    if (this.validateSaleAccount().validate()) {
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        this.saleAccount.storeId = this.storeId;
        if (this.$route.params.id) {
          await saleAccountService.updateSaleAccount(this.saleAccount);
          this.showAlert(true, "Sale Account updated successfully");
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: { id: this.storeId.toString(), tab: 'SaleAccount' },
            });
        } else {
          await saleAccountService.saveSaleAccount(this.saleAccount);
          this.showAlert(true, "Sale Account created successfully");
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: { id: this.storeId.toString(), tab: 'SaleAccount' },
            });
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }


  public async getSaleAccountById(id: string): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await saleAccountService.getSaleAccountById(Number(id));
      this.saleAccount = response;
      this.setFields();
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }



  public async getStores(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'storeId');
      const userStores = await storeService.getUserStoresList();
      this.stores = userStores.results;
      this.setFields();
    } finally {
      if (!this.storeId) {
        this.formlyHideSkeleton(this.formFields, 'storeId');
      }
    }
  }




  public setFields(): void {
    this.formFields = [
      // {
      //           key: 'storeId',
      //           type: 'v-alynk-select',
      //           required: true,
      //           templateOptions: {
      //               label: this.$t('availability.availabilityFields.storeName') as string,
      //               required: true,
      //               disabled: this.$route.params.id ? true : false,
      //               items: this.stores,
      //               value: 'id',
      //               text: 'dealershipName',
      //               altag: 'Store Name',
      //               loading: false,
      //               rules: [
      //                   v => this.required('Store Name', v)
      //               ]
      //           },
      //       },
      {
        key: 'make',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Make",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Make', v)
          ]
        },
      },
      {
        key: 'modelCode',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Model Code",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Model Code', v)
          ]
        },
      },
      {
        key: 'model',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Model",
          required: false,
          disabled: false,
          loading: false,
        },
      },
      {
        key: 'inventoryAccountNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {

          label: "Inventory Account Number",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Inventory Account Number', v)
          ]
        },
      },
      {
        key: 'saleAccountNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Sale Account Number",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Sale Account Number', v)
          ]
        },
      },
      {
        key: 'department',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Department",
          required: false,
          disabled: false,
          loading: false,
        },
      },


      {
        key: 'saleGroup',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Sale Group",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Sale Group', v)
          ]
        },
      },
      {
        key: 'inventoryAccountDescription',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Inventory Account Description",
          required: false,
          disabled: false,
          loading: false,
        },
      },
      {
        key: 'saleAccountDescription',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Sale Account Description",
          required: false,
          disabled: false,
          loading: false,
        },
      },
      {
        key: 'uid',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "UID",
          required: false,
          disabled: false,
          loading: false,
        },
      },

    ];
  }
}
